import * as React from "preact";
import { FunctionComponent } from "preact";

export interface ILabel {
  key: string;
  value: string;
}

const StringInput: FunctionComponent<ILabel> = ({ key, value }) => {
  return (
    <label
      for={key}
      className="base-form__label"
    >
      {value}
    </label>
  );
};

export default StringInput;
